import { render, staticRenderFns } from "./SemiologiaAlergiologica.vue?vue&type=template&id=481bf7a9"
import script from "./SemiologiaAlergiologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaAlergiologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports